<template>
  <div class="nodata">
    <img src="@/assets/new/nodata.png" alt="" />
    <p>{{ $t('public').noData }}</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.nodata {
  text-align: center;
  img {
    width: 60px;
    height: 60px;
    margin: 20px 0 5px;
  }
}
</style>
